import React, { useEffect } from 'react';
import { useMap, useMapEvent } from 'react-leaflet';
import L from 'leaflet';

interface MapEventsProps {
  setMap: (map: L.Map) => void;
  setClickedLocation: (location: [number, number] | null) => void;
}

const MapEvents: React.FC<MapEventsProps> = ({ setMap, setClickedLocation }) => {
  const leafletMap = useMap();

  useEffect(() => {
    setMap(leafletMap);
    leafletMap.on('moveend', () => {});

    return () => {
      leafletMap.off('moveend', () => {});
    };
  }, [leafletMap, setMap]);

  useMapEvent('click', (e) => {
    setClickedLocation([e.latlng.lat, e.latlng.lng]);
  });

  return null;
};

export default MapEvents;